/**
 * Decodes HTML entities in a string
 * Converts entities like &#39; to ' and &amp; to &
 */
export const decodeHtmlEntities = (text: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};
